import React, { useState } from 'react'
import AddReport from '../../components/student/AddReport'
import DailyReport from './DailyReport'
import ReportsListing from './ReportsListing'

export default function Reports() {
  const [reportToEdit, setReportToEdit] = useState(null);

  return (
    <div className="w-full">
      {/* <div className="">
        <DailyReport reportToEdit={reportToEdit} onReportUpdated={() => setReportToEdit(null)} />
      </div> */}
      <div className="">
        <ReportsListing reportToEdit={reportToEdit} onEditReport={setReportToEdit} />
      </div>
    </div>
  )
}
